import React from 'react';
import '../Services/services.css';

const services = [
  {
    icon: '/room/img3.png',
    title: '3 BHK with Swimming Pool',
    desc: 'Perfect for groups up to 6 guests. Features indoor swimming pool, fully equipped modular kitchen, and modern amenities.',
    pricing: {
      weekdays: '₹9,500',
      weekends: '₹10,500'
    },
    features: ['Indoor Swimming Pool', 'Modular Kitchen', 'Bar & Entertainment', 'Netflix, Prime, Hotstar']
  },
  {
    icon: '/room/img5.png',
    title: '3 BHK with Swimming Pool & Movie Theatre',
    desc: 'Luxury experience with personal movie theatre featuring 6 recliner seats, plus all pool amenities.',
    pricing: {
      weekdays: '₹10,500',
      weekends: '₹11,500'
    },
    features: ['Personal Movie Theatre', '6 Recliner Seats', 'Indoor Swimming Pool', 'Premium Entertainment']
  },
  {
    icon: '/room/img6.png',
    title: '6 BHK with All Access',
    desc: 'Ultimate luxury experience with complete villa access, perfect for large groups and special events.',
    pricing: {
      weekdays: '₹16,000',
      weekends: '₹18,500'
    },
    features: ['Complete Villa Access', 'All Amenities Included', 'Perfect for Events', 'Maximum Luxury']
  }
];

const whyChooseItems = [
  {
    icon: '/services/pool.JPG',
    title: 'Indoor Swimming Pool',
    desc: "Enjoy a private swim in the villa's exclusive indoor pool"
  },
  {
    icon: '/services/theatre.JPG',
    title: 'Personal Movie Theatre',
    desc: 'Relax in a home theatre with 6 recliner seats'
  },
  {
    icon: '/services/bar.JPG',
    title: 'Modern Amenities',
    desc: 'Fully equipped modular kitchen, bar, and entertainment options'
  },
  {
    icon: '/services/miniGoa.jpg',
    title: 'Prime Location',
    desc: '75 km from Dalhousie, 86 km from Dharamshala',
    isMap: true
  },
  {
    icon: '/services/exclusiveExperience.JPG',
    title: 'Exclusive Experience',
    desc: 'A cozy yet luxurious property with a homely feel'
  },
  {
    icon: '/services/miniGoa.jpg',
    title: 'Nearby Attractions',
    desc: 'Mini Goa, Pandava Mandir, Oldest Shani Dev mandir, Damn Area'
  }
];

const ServicesSection = () => (
  <section className="services-section">
    <h1 className="services-title">Our Price Options</h1>
    <p className="services-desc">Choose the perfect stay for your group and enjoy premium amenities at the best prices.</p>
    <div className="services-grid">
      {services.map((s, idx) => (
        <div className={`service-card${idx===0?' active':''}`} key={s.title}>
          <div className="service-icon">
            <img src={s.icon} alt={s.title} />
          </div>
          <h3 className="service-title">{s.title}</h3>
          <p className="service-desc">{s.desc}</p>
          <div className="pricing-section">
            <div className="pricing-item">
              <span className="pricing-label">Weekdays:</span>
              <span className="pricing-value">{s.pricing.weekdays}</span>
            </div>
            <div className="pricing-item">
              <span className="pricing-label">Weekends:</span>
              <span className="pricing-value">{s.pricing.weekends}</span>
            </div>
          </div>
          <div className="features-list">
            {s.features.map((feature, index) => (
              <div key={index} className="feature-item">
                <span className="feature-icon">✓</span>
                <span className="feature-text">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
    <div className="why-choose-section">
      <h2 className="why-choose-title">Why Choose Rameshwaram Villa?</h2>
      <div className="why-choose-grid">
        {whyChooseItems.map((item, index) => (
          <div key={index} className="why-choose-item">
            <div className="why-choose-icon">
              <img src={item.icon} alt={item.title} />
            </div>
            <h4>{item.title}</h4>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesSection; 